import { EVENT_TYPES, EventsState, EventStatusSettings } from './types';
import { MantineTheme } from '@mantine/core';

export const getEventsInitialState = (theme: MantineTheme): EventsState => {
  return {
    cafe: {
      statusGrade: 0,
      count: 0,
      variant: 'filled',
      bg: `${theme.colors['pink'][1]}`,
      color: `${theme.colors['pink'][4]}`,
      icon: false,
      events: [],
    },
    popup: {
      statusGrade: 0,
      count: 0,
      variant: 'filled',
      bg: `${theme.colors['orange'][1]}`,
      color: `${theme.colors['orange'][4]}`,
      icon: false,
      events: [],
    },
    delivery: {
      statusGrade: 0,
      variant: 'filled',
      bg: `${theme.colors['cyan'][1]}`,
      color: `${theme.colors['cyan'][4]}`,
      count: 0,
      icon: false,
      events: [],
    },

    catering: {
      statusGrade: 0,
      count: 0,
      bg: `${theme.colors['violet'][1]}`,
      color: `${theme.colors['violet'][4]}`,
      variant: 'filled',
      icon: false,
      events: [],
    },
  };
};

export const eventStateByStatus: Record<string, EventStatusSettings> = {
  completed: {
    statusGrade: 5,
    variant: 'filled',
    icon: false,
  },
  partially_ready: {
    statusGrade: 4,
    variant: 'filled',
    icon: true,
  },
  not_ready: {
    statusGrade: 3,
    variant: 'outline',
    icon: true,
  },
  ready: {
    statusGrade: 2,
    variant: 'filled',
    icon: false,
  },
  scheduled: {
    statusGrade: 1,
    variant: 'transparent',
    icon: false,
  },
};

export const eventTypeFilters = EVENT_TYPES.map((type) => ({
  value: true,
  label: type.toUpperCase(),
}));

export const ALL_VENDORS = '__all__';

export const CalendarEventStatusLabels = {
  completed: 'Completed',
  scheduled: 'Scheduled',
  not_ready: 'Not Ready',
  ready: 'Ready',
};
